/**
 * Human wording for the CBAM indirect-emissions enum codes.
 *
 * The regulation defines the codes; these are what we print instead. Shared
 * because two surfaces now publish the same four regulatory fields for the same
 * factor — the emissions report PDF and the portal's xlsx export — and a
 * supplier whose PDF says "Received from the grid" while their spreadsheet says
 * something else has caught us contradicting ourselves about their own data.
 *
 * Lives outside the PDF module on purpose: importing
 * `CbamStock/components/SalesOrderEmissionsReportPDF` for three strings would
 * pull @react-pdf into the portal Studio page, which never renders a document.
 *
 * Not translated. Neither is the PDF that has printed these strings all along,
 * and splitting the pair so one localises and the other does not would be worse
 * than leaving both in English until the report is localised as a whole.
 */

/** `ElectricitySource` — where the electricity came from. */
export const ELECTRICITY_SOURCE_LABELS = {
  SOE01: 'Direct technical link to generator',
  SOE02: 'Bilateral power purchase agreement',
  SOE03: 'Received from the grid',
};

/**
 * Resolve a code, falling back to the code itself.
 *
 * An unrecognised code is still information — the regulation can add one before
 * we add a label — so it prints as-is rather than vanishing.
 */
export const electricitySourceLabel = (code) =>
  code == null || code === '' ? null : (ELECTRICITY_SOURCE_LABELS[code] ?? code);
